/**
 * 浏览器返回键拦截
 */

let initialize = false;
const BackFuncs = [];

/**
 * 添加返回事件拦截事件
 * @param f
 */
export function addBackFunc(f) {
  BackFuncs.push(f);
}

/**
 * 移除返回事件拦截事件
 * @param f
 */
export function removeBackFunc(f) {
  const index = BackFuncs.indexOf(f);
  if (index !== -1) {
    BackFuncs.splice(index, 1);
  }
  window.removeEventListener('popstate', f);
}

/**
 * 初始化
 */
export function init() {
  if (initialize) {
    return;
  }
  initialize = true;

  window.addEventListener('popstate', function (e) {
    for (const f of BackFuncs) {
      f(e);
    }
  });
}
